import { keepPreviousData, useInfiniteQuery } from "@tanstack/react-query";
import { service, useAuthConfig } from "@theprelude/core";

export const useInfiniteAlertAffectedResources = (alertId: string) => {
  const authConfig = useAuthConfig();

  return useInfiniteQuery({
    queryKey: [authConfig, "detect", "paginated", "alert-affected", alertId],
    queryFn: async ({ pageParam = 0 }) => {
      const data = await service(authConfig).detect.getAlertAffectedResources(
        alertId,
        { skip: pageParam },
      );
      return data;
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) => {
      const totalLoaded = allPages.reduce((sum, page) => sum + page.length, 0);
      // Continue if we got a full page (500 items)
      return lastPage.length === 500 ? totalLoaded : undefined;
    },
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    // Flatten pages for easier consumption, similar to useInfiniteODataQuery
    select: (data) => ({
      data: data.pages.flat(),
      totalCount: undefined, // No total count available from this API
    }),
  });
};
